import React from "react";
import { useAppSelector } from "../../../../store/hooks";
import { formatCurrency } from "../../../../utils/formatting";
// Removed unused import

export const BreakawayWeaponStatsFooter: React.FC = () => {
  const breakawayHull = useAppSelector((state) => state.breakawayHull);
  const weaponMounts = useAppSelector((state) => state.shipBuilder.weaponMounts) || [];
  const defensiveSystems = useAppSelector((state) => state.shipBuilder.defensiveSystems) || [];
  
  // Calculate total weapon stats across all sections
  const calculateTotalStats = () => {
    if (!breakawayHull?.sections) {
      return {
        weaponsVolume: 0,
        ammoVolume: 0,
        defenceVolume: 0,
        totalVolume: 0,
        weaponsCost: 0,
        ammoCost: 0,
        defenceCost: 0,
        totalCost: 0,
        weaponsPower: 0,
        defencePower: 0,
        totalPower: 0
      };
    }

    // Calculate weapon stats from actual weapon mounts
    const weaponsVolume = weaponMounts.reduce((total, mount) => total + mount.tons, 0);
    const weaponsCost = weaponMounts.reduce((total, mount) => total + mount.cost, 0);
    const weaponsPower = weaponMounts.reduce((total, mount) => total + mount.power, 0);

    // Calculate defensive system stats
    const defenceVolume = defensiveSystems.reduce((total, system) => total + system.weight, 0);
    const defenceCost = defensiveSystems.reduce((total, system) => total + system.cost, 0);
    const defencePower = defensiveSystems.reduce((total, system) => total + system.power, 0);

    // Calculate ammo stats (placeholder for now)
    const ammoVolume = 0;
    const ammoCost = 0;

    return {
      weaponsVolume,
      ammoVolume,
      defenceVolume,
      totalVolume: weaponsVolume + ammoVolume + defenceVolume,
      weaponsCost,
      ammoCost,
      defenceCost,
      totalCost: weaponsCost + ammoCost + defenceCost,
      weaponsPower,
      defencePower,
      totalPower: weaponsPower + defencePower
    };
  };

  const stats = calculateTotalStats();

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-800 text-white p-4 z-40">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-3 gap-8">
          {/* Total Consumed Volume */}
          <div>
            <h4 className="text-sm font-semibold text-gray-300 mb-2">Total Consumed Volume</h4>
            <div className="space-y-1 text-sm">
              <div className="flex justify-between">
                <span>Weapons:</span>
                <span>{stats.weaponsVolume.toFixed(2)} tons</span>
              </div>
              <div className="flex justify-between">
                <span>Ammo:</span>
                <span>{stats.ammoVolume.toFixed(2)} tons</span>
              </div>
              <div className="flex justify-between">
                <span>Defence:</span>
                <span>{stats.defenceVolume.toFixed(2)} tons</span>
              </div>
              <div className="flex justify-between font-semibold border-t border-gray-600 pt-1">
                <span>Total:</span>
                <span>{stats.totalVolume.toFixed(2)} tons</span>
              </div>
            </div>
          </div>

          {/* Total Cost */}
          <div>
            <h4 className="text-sm font-semibold text-gray-300 mb-2">Total Cost</h4>
            <div className="space-y-1 text-sm">
              <div className="flex justify-between">
                <span>Weapons:</span>
                <span>{formatCurrency(stats.weaponsCost)}</span>
              </div>
              <div className="flex justify-between">
                <span>Ammo:</span>
                <span>{formatCurrency(stats.ammoCost)}</span>
              </div>
              <div className="flex justify-between">
                <span>Defence:</span>
                <span>{formatCurrency(stats.defenceCost)}</span>
              </div>
              <div className="flex justify-between font-semibold border-t border-gray-600 pt-1">
                <span>Total:</span>
                <span>{formatCurrency(stats.totalCost)}</span>
              </div>
            </div>
          </div>

          {/* Total Power Consumption */}
          <div>
            <h4 className="text-sm font-semibold text-gray-300 mb-2">Total Power Consumption</h4>
            <div className="space-y-1 text-sm">
              <div className="flex justify-between">
                <span>Weapons:</span>
                <span>{stats.weaponsPower} Power</span>
              </div>
              <div className="flex justify-between">
                <span>Defence:</span>
                <span>{stats.defencePower} Power</span>
              </div>
              <div className="flex justify-between font-semibold border-t border-gray-600 pt-1">
                <span>Total:</span>
                <span>{stats.totalPower} Power</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
